// modules
import FetchService from 'modules/Fetch/service';
// constants
import { CancelOrderRequest } from 'modules/TradesPW3/Orders/types';
import { OrderRequestMode } from '../consts';

class OrderingServiceFetch {
  async placeOrderRequest(commonOrderRequestData: CommonOrdersRequest) {
    return FetchService.request<'COMMON_ORDER', CommonOrdersResponse>(
      'COMMON_ORDER',
      '/order',
      'PLACE_ORDER',
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: {
          data: commonOrderRequestData,
        },
        withDeviceDetails: true,
        addUserId: true,
        addProfileId: true,
      },
    );
  }

  async modifyOrderRequest(placeOrderData: CommonOrdersRequest) {
    return FetchService.request<'COMMON_ORDER', CommonOrdersResponse>(
      'COMMON_ORDER',
      '/order',
      'MODIFY_ORDER',
      {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
        },
        body: { data: placeOrderData },
        withDeviceDetails: true,
        addUserId: true,
        addProfileId: true,
      },
    );
  }

  async cancelOrderRequest(orders: CancelOrderRequest[]) {
    const data = {
      requestMode: OrderRequestMode.REGULAR,
      orders,
      context: 'TV',
      orderTime: Date.now(),
    };

    return FetchService.request<
      'COMMON_ORDER',
      CommonOrdersResponse
    >('COMMON_ORDER', '/order', 'CANCEL_ORDER', {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
      },
      body: { data },
      withDeviceDetails: true,
      addUserId: true,
      addProfileId: true,
    });
  }

  async convertPositionRequest(data: ConvertPositionReqData) {
    return FetchService.request<'COMMON_ORDER', CommonOrdersResponse>(
      'COMMON_ORDER',
      '/convert',
      'CONVERT_POSITION',
      {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: { data },
        withDeviceDetails: true,
        addUserId: true,
        addProfileId: true,
      },
    );
  }
}

export default new OrderingServiceFetch();
